var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expense__actions flex items-center flex-nowrap justify-between p-4 border border-r-0 border-l-0 border-solid d-theme-border-grey-light"},[_c('div',{staticClass:"flex justify-start content"},[_vm._t("left")],2),_c('div',{staticClass:"flex justify-end content ml-4"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }